import React, { useEffect, useRef } from 'react'
import { AnimatePresence, AnimateSharedLayout, motion } from 'framer-motion'
import { useOutsideClick } from '../../utils/hooks'

/**
 * FloatingForm:
 *
 * Opciones:
 * @param {ReactElement} children Elemento pasado al FloatingForm. 
 * @param {boolean} visible Propiedad que determina si el FloatinForm se muestra
 */
const FloatingForm: React.FC<FloatingFormProps> = ({
  children,
  visible,
  onClose,
  topClass,
  rightClass,
  containerClass = ""
}) => {

  const wrapperRef = useRef(null)
  useOutsideClick(wrapperRef, () => onClose())

  const callback = (e) => {
    if (e.code === 'Escape') onClose()
  }

  useEffect(() => {
    if (visible) {
      window.addEventListener('keydown', callback)
    }
    return () => {
      window.removeEventListener('keydown', callback)
    }
    //eslint-disable-next-line
  }, [visible])

  return (
    <div className={`absolute w-full ${topClass} ${rightClass}`} ref={wrapperRef}>
      <AnimateSharedLayout type="crossfade">
        <AnimatePresence>
          {visible && (
            <div className={`absolute w-1/4 text-center top-full mt-2.5 -right-2 z-50 dark:border-gray-800 ${containerClass}`}>
              <motion.div
                className="rounded-lg p-2 px-4 relative shadow-md bg-white dark:bg-gray-900 "
                initial="closed"
                animate="open"
                exit="closed"
                transition={{ duration: 0.2, ease: [0.04, 0.62, 0.23, 0.98] }}
                variants={{
                  open: { opacity: 1 },
                  closed: { opacity: 0 },
                }}
              >
                {children}
              </motion.div>
            </div>
          )}
        </AnimatePresence>
      </AnimateSharedLayout>
    </div>
  )
}

export default FloatingForm
interface FloatingFormProps {
  children: any
  visible: boolean
  onClose: Function
  topClass: string  
  rightClass: string
  containerClass?: string
}
